/**
 *  @class Cache class for managing the scan elements that manages localy stored data.
 */

import { MemoryManager } from '../memory-manager';
import { CacheElement } from './cache-element';

export default class OrethotileCache extends CacheElement {
  constructor(key: string, data: any, clearTimeout: number, clearCallback: any, size = 0) {
    super(key, data, clearTimeout, clearCallback, size, 'orthotile');
  }

  dispose() {
    this.data?.dispose?.();
    MemoryManager.getInstance().release(this.getSize(), this.type);
  }
}
